import React, { FC } from "react";
import Article from "../../Article";

const Landing: FC = () => {
  return <Article header="Velkommen" />;
};

export default Landing;
